import { useProfile } from '@/hooks/useProfile';

/**
 * `true` — текущий пользователь НЕ прошёл аттестацию (профиль загружен и `isVerified === false`).
 * Пока профиль грузится, возвращает `false` — чтобы не мигать предупреждением-ограничением до загрузки
 * (строгое сравнение с `false`: `undefined === false` → `false`). Источник — `profile.isVerified`
 * (на бэке — `FULL_VERIFIED`).
 */
export function useAttestationRequired(): boolean {
  const { data: profile } = useProfile();
  return profile?.isVerified === false;
}
